const respiratorySymptoms=[

{symptom:"smoker",
displayAs:"Patient is/ has ever been smoker",
questionGroup: "smoker"
},

{symptom:"asbestos",
displayAs:"Asbestos exposure",
questionGroup: "asbestos"
},

{symptom:"haemoptysis",
displayAs:"Haemoptysis",
questionGroup: "haemoptysis"
},

{symptom:"cough",
displayAs:"Cough",
questionGroup: "cough"
},

{symptom:"sob",
displayAs:"Shortness of breath",
questionGroup: "sob"
},

{symptom:"chestInfection",
displayAs:"Persistent/ recurrent chest infection",
questionGroup: "freqAndDuration"
},

{symptom:"fingerClubbing",
displayAs:"Finger clubbing",
questionGroup: "clubbing"
},

{symptom:"neckNodes",
displayAs:"Supraclavicular / cervical lymphadenopathy",
questionGroup: "neckNodes"
},

{symptom:"chestSignsLung",
displayAs:"Chest finding suggesting lung cancer",
questionGroup: "lungSigns"
},

{symptom:"chestSignsPleural",
displayAs:"Chest signs suggesting pleural disease",
questionGroup: "pleural"
}


]


export default respiratorySymptoms